export default __webpack_public_path__ + "static/media/trainingPlan.7b490cae.svg";